import OpenShiftRequests from '@/data/openshiftRequests/model';

import { createSelector } from '@reduxjs/toolkit';

const getStateOpenShiftRequests = state => state.data.openShiftRequests.items;

export const getOpenShiftRequests = getStateOpenShiftRequests;

export const getActionableOpenShiftRequests = createSelector([getOpenShiftRequests], requests =>
  requests.filter(request => {
    return (
      request.status === OpenShiftRequests.Status.PENDING &&
      request.user_requests.length > 0 &&
      request.user_requests.some(userRequest => userRequest.deleted_at === null)
    );
  }),
);
